import { Timestamp, createTimestamp } from 'vopay';
import { parse } from 'date-fns';

// 'yyyy-MM-dd' filter value -> local start-of-day Timestamp.
export default function toDayTimestamp(value: string): Timestamp {
  const timestamp = createTimestamp(parse(value, 'yyyy-MM-dd', new Date()).getTime());

  // createTimestamp only returns undefined for undefined input, so this never
  // throws — it exists to narrow the return type without a cast.
  if (timestamp === undefined) throw new Error(`Invalid date filter value: ${value}`);

  return timestamp;
}
